import { PropsWithChildren, useEffect } from 'react';
import { useIpKycService } from '../../hooks/useIpKycService';
import useCoingeckoStore from '../../stores/coingeckoStore';

const AppWrapper = ({ children }: PropsWithChildren) => {
  useIpKycService();
  const { fetchMarketData, fetchCategories } = useCoingeckoStore();

  useEffect(() => {
    // Initialize CoinGecko data
    fetchMarketData();
    fetchCategories();
  }, [fetchMarketData, fetchCategories]);

  return children;
};

export default AppWrapper;
